// extracted by mini-css-extract-plugin
export default {"flex":"flex---R4gXR","icon":"icon---crJ8R","open":"open---WZ5_x","voided":"voided---mcW67"};